import React, { useState, useMemo, useEffect } from 'react';
import { get, round } from 'lodash';
import { Button, Typography } from '@telus-uds/components-web';
import { Formik, Form, Field } from 'formik';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import Edit from '@telus-uds/palette-allium/build/web/icons/Edit';
import PropTypes from 'prop-types';
import Modal from '../../../design/shared/modal';

import {
  ModalFieldLabel,
  ModalFooter,
  Table,
  Tr,
  Td,
  Th,
  TdImp,
  TdLabel
} from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';

// Function to get distinct categories from the data
// const getDistinctCategories = list => {
//   return [...new Set(list.map(item => item.Category))];
// };

// Function to get distinct item description line 2 for a given category
// const getDistinctItemDescriptionLine2 = (list, category) => {
//   const filteredData = list.filter(item => item.Category === category);
//   return [
//     ...new Set(filteredData.map(item => item['Item Description Line 2']))
//   ];
// };
const OcrdService = ({ onChange, defaultValues, orderData }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [
    selectionAddService,
    setSelectionAddService
  ] = useState([]);
  const [errors, setErrors] = useState();

  useEffect(() => {
    if(!selectionAddService.length){
      setSelectionAddService(get(defaultValues, 'selections', []));
    }
  }, [orderData]);

  const categories = ['One Time', 'Monthly']
  const totals = useMemo(() => {
    let totalMonthlyRecurring = 0;
    let totalOneTimePrice = 0;
    selectionAddService.forEach(item => {
      if(item.chargeType ==="One Time"){
        totalOneTimePrice += round(item.chargeAmount, 2);
      }else{
        totalMonthlyRecurring += round(item.chargeAmount, 2);
      }
    });
    return {
      totalMonthlyRecurringPrice: totalMonthlyRecurring,
      totalOneTimePrice: totalOneTimePrice
    };
  }, [selectionAddService]);

  const adjustedTotalPrice = useMemo(() => {
    const totalMonthly = totals.totalMonthlyRecurringPrice;
    const totalOneTime = totals.totalOneTimePrice;
    return {
      totalMonthly,
      totalOneTime
    };
  }, [totals]);

  const showModal = () => {
    setModalData(null);
    setModalVisible(true);
  };

  const onCloseModal = () => {
    setModalVisible(false);
  };

  const addLicencingRow = row => {
    if (row.qtyOfLicenses <= 0) {
      setErrors(prevErrors => ({
        ...prevErrors,
        qtyOfLicenses: 'Quantity of Licenses must be greater than 0'
      }));
      return;
    }
    setSelectionAddService([...selectionAddService, row]);
  };

  const editItem = (e, row) => {
    e.preventDefault();
    setModalData(row);
    setModalVisible(true);
  };

  const handleWheel = e => e.target.blur();

  const deleteItem = (e, idx) => {
    e.preventDefault();
    setSelectionAddService([
      ...selectionAddService.slice(0, idx),
      ...selectionAddService.slice(idx + 1)
    ]);
  };

  useEffect(() => {
    onChange({
      selections: selectionAddService,
      adjustedTotalPrice
    });
  }, [selectionAddService, adjustedTotalPrice]);

  return (
    <div>
      {!!selectionAddService.length && (
        <Table>
          <Th><Typography>Description</Typography></Th>
          <Th><Typography>Site</Typography></Th>
          <Th><Typography>Hours</Typography></Th>
          <Th><Typography>Charge Type</Typography></Th>
          <Th><Typography>Charge Amount</Typography></Th>
          {/* <Th>Subscription Line Options</Th> */}
          <Th colSpan={2}><Typography>Actions</Typography></Th>{' '}
          {/* Add this column for edit/delete buttons */}
          {selectionAddService.map(
            (
              {
                hours,
                subscriptionLineOption,
                description,
                site,
                chargeAmount,
                chargeType
              },
              idx
            ) => (
              // eslint-disable-next-line react/no-array-index-key
              <Tr key={`${chargeType}-${subscriptionLineOption}-${idx}`}>
                <Td><Typography>{description}</Typography></Td>
                <Td><Typography>{site}</Typography></Td>
                <Td><Typography>{hours}</Typography></Td>
                <Td><Typography>{chargeType}</Typography></Td>
                <Td><Typography>{chargeAmount}</Typography></Td>
                <Td>
                  <Button
                    icon={Edit}
                    onPress={e => editItem(e, selectionAddService[idx])}
                    variant={{ text: true }}
                    accessibilityLabel="Edit"
                  />
                </Td>
                <Td>
                  <Button
                    icon={Delete}
                    onPress={e => deleteItem(e, idx)}
                    variant={{ text: true }}
                    accessibilityLabel="Delete"
                  />
                </Td>
              </Tr>
            )
          )}
          <Tr>
            <TdLabel colSpan={4}>Total</TdLabel>
            <TdImp>
              <Typography>{formatCurrency(
                totals.totalMonthlyRecurringPrice + totals.totalOneTimePrice
              )}</Typography>
            </TdImp>
            <Td />
          </Tr>
        </Table>
      )}
      <Button onClick={showModal}>Add Service</Button>
      <Modal
        open={isModalVisible}
        setOpen={onCloseModal}
        size="large"
        header={modalData ? 'Edit Service' : 'Add Service'}
      >
        <Formik
          initialValues={
            modalData || {
              hours: '',
              site: '',
              description: '',
              chargeType: '',
              chargeAmount: 0
            }
          }
          onSubmit={values => {
            if (modalData) {
              // Update existing row
              const updatedSelections = [...selectionAddService];
              updatedSelections[
                selectionAddService.indexOf(modalData)
              ] = values;
              setSelectionAddService(updatedSelections);
            } else {
              // Add new row
              addLicencingRow(values);
            }
            if (
              values.qtyOfLicenses !== 0 &&
              (!errors || !errors.qtyOfLicenses)
            ) {
              onCloseModal();
            } else {
              showModal();
            }
          }}
        >
          {({ setFieldValue, submitForm }) => (
            <Form>
              <div>
                <ModalFieldLabel htmlFor="description">
                  Description:
                </ModalFieldLabel>
                <Field
                  type="text"
                  id="description"
                  name="description"
                  className="frg-input-field color-light"
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  required
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="site">Site:</ModalFieldLabel>
                <Field
                  type="text"
                  id="site"
                  name="site"
                  className="frg-input-field color-light"
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  required
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="hours">Hours:</ModalFieldLabel>
                <Field
                  type="number"
                  id="hours"
                  name="hours"
                  className="frg-input-field color-light"
                  // value={values.hours}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                />
              </div>
              <div>
                <ModalFieldLabel>Charge Type:</ModalFieldLabel>
                <Field
                  as="select"
                  id="chargeType"
                  name="chargeType"
                  className="frg-input-field color-light"
                  onChange={e => {
                    const selectedCategory = e.target.value;
                    setFieldValue('chargeType', selectedCategory);
                    setFieldValue('subscriptionLineOption', ''); // Reset Subscription Line Option
                  }}
                  required
                >
                  <option value="">Select Charge Type</option>
                  {categories.map(category => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </Field>
              </div>
              <div>
                <ModalFieldLabel htmlFor="chargeAmount">
                  Charge Amount:
                </ModalFieldLabel>
                <Field
                  type="number"
                  id="chargeAmount"
                  name="chargeAmount"
                  className="frg-input-field color-light"
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const selectedCategory = e.target.value;
                    if (selectedCategory >= 0) {
                      setFieldValue('chargeAmount', selectedCategory);
                    }else{
                      setFieldValue('chargeAmount', 0);
                    }
                  }}
                />
              </div>
              <ModalFooter>
                <Button onClick={submitForm}>Add</Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

OcrdService.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({}).isRequired,
  orderData: PropTypes.shape({}).isRequired
};

export default OcrdService;
